module.exports = __webpack_public_path__ + "static/media/04.1f5280fc.mp3";